export default __webpack_public_path__ + "static/media/iconStarYellow.a2b33a7e.svg";